export default {
  GET_CUSTOMER_HAS_KUSPIT_ACCOUNT_QUERY: Symbol.for('GET_CUSTOMER_HAS_KUSPIT_ACCOUNT_QUERY'),
  CUSTOMER_HAS_KUSPIT_ACCOUNT_REPOSITORY: Symbol.for('CUSTOMER_HAS_KUSPIT_ACCOUNT_REPOSITORY'),
  CUSTOMER_HAS_KUSPIT_ACCOUNT_STATE_MANAGER: Symbol.for('CUSTOMER_HAS_KUSPIT_ACCOUNT_STATE_MANAGER'),
};
